module.exports = __webpack_public_path__ + "img/18m3.59f68eaf.jpg";